import React, {useContext} from 'react'
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItemUnit = ({ rowId }) => {

    const {rowData} = useContext(RecipeConText)
    const [rowState] = rowData

    return(
       <React.Fragment>
           {
               rowState[rowId].data ? rowState[rowId].data.unit : null
           }
       </React.Fragment>
    )
}
export default RecipeItemUnit